var map = {
	"./About.svg": 35,
	"./Arrow.svg": 36,
	"./Calendar.svg": 37,
	"./Download.svg": 38,
	"./Facebook line.svg": 39,
	"./Infographic.svg": 40,
	"./Presentation.svg": 41,
	"./Press Release.svg": 42,
	"./Quote.svg": 43,
	"./Tag.svg": 44,
	"./Transcript.svg": 45,
	"./Webcast.svg": 46,
	"./arrow-1.svg": 47,
	"./arrow-2.svg": 48,
	"./arrow_to_be_collapse.svg": 49,
	"./arrow_to_be_extend.svg": 50,
	"./call.svg": 51,
	"./core-value-1.svg": 52,
	"./core-value-2.svg": 53,
	"./core-value-3.svg": 54,
	"./facebook.svg": 55,
	"./globe.svg": 56,
	"./impact.svg": 57,
	"./instagram.svg": 58,
	"./linkedin.svg": 59,
	"./people.svg": 60,
	"./product.svg": 61,
	"./search.svg": 62,
	"./vng.svg": 63,
	"./youtube.svg": 64
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34;